import React from "react";

interface TaskIdIconProps {
  className?: string;
  width?: number;
  height?: number;
}

const TaskIdIcon: React.FC<TaskIdIconProps> = ({ className, width = 40, height = 40 }) => {
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 40 40" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect width="40" height="40" rx="20" fill="#FFE8F9"/>
      <path 
        d="M20.0002 14.9997C20.9168 14.9997 21.6668 15.7497 21.6668 16.6663C21.6668 17.583 20.9168 18.333 20.0002 18.333C19.0835 18.333 18.3335 17.583 18.3335 16.6663C18.3335 15.7497 19.0835 14.9997 20.0002 14.9997ZM20.0002 23.333C22.2502 23.333 24.8335 24.408 25.0002 24.9997H15.0002C15.1918 24.3997 17.7585 23.333 20.0002 23.333ZM20.0002 13.333C18.1585 13.333 16.6668 14.8247 16.6668 16.6663C16.6668 18.508 18.1585 19.9997 20.0002 19.9997C21.8418 19.9997 23.3335 18.508 23.3335 16.6663C23.3335 14.8247 21.8418 13.333 20.0002 13.333ZM20.0002 21.6663C17.7752 21.6663 13.3335 22.783 13.3335 24.9997V26.6663H26.6668V24.9997C26.6668 22.783 22.2252 21.6663 20.0002 21.6663Z" 
        fill="#4F4A4A"
      />
    </svg>
  );
};

export default TaskIdIcon;
